import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'

export default function Pad(props) {
  const { nodes, materials } = useGLTF('models/pad.glb')
  const groupRef = useRef();
  useFrame(() => {
    if (groupRef.current) {
      groupRef.current.rotation.y += 0.015;
    }
  });


  return (
    <group ref={groupRef} {...props} dispose={null}>
      <group scale={0.01}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane_White_0.geometry}
          material={materials.White}
          position={[0, 0.36, 17.169]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder_White_0.geometry}
          material={materials.White}
          position={[58.986, 24.627, 50.419]}
          rotation={[-0.088, 0, 0]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane002_White_0.geometry}
          material={materials.White}
          position={[-66.452, 24.102, 49.894]}
          rotation={[0, 0, Math.PI]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane005_White_0.geometry}
          material={materials.White}
          position={[32.073, -0.16, 56.127]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle001_White_0.geometry}
          material={materials.White}
          position={[32.074, 0.564, 62.071]}
          rotation={[-0.127, 0, 0]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane001_White_0.geometry}
          material={materials.White}
          position={[60.166, 50.686, 23.471]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane003_White_0.geometry}
          material={materials.White}
          position={[0, 40.735, 46.112]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane004_White_0.geometry}
          material={materials.White}
          position={[0, -3.898, 49.685]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane006_White_0.geometry}
          material={materials.White}
          position={[0, 8.556, 39.362]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube_White_0.geometry}
          material={materials.White}
          position={[0, 53.965, 28.505]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube001_White_0.geometry}
          material={materials.White}
          position={[44.272, 43.256, 48.967]}
          rotation={[-0.192, 0.041, -0.209]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube002_White_0.geometry}
          material={materials.White}
          position={[0, -9.663, 50.471]}
          rotation={[0.34, 0, 0]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane007_White_0.geometry}
          material={materials.White}
          position={[-49.069, 24.317, 52.018]}
          rotation={[-0.181, -0.254, -0.019]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane008_White_0.geometry}
          material={materials.White}
          position={[-57.75, 32.933, 49.894]}
          rotation={[0, -0.14, Math.PI / 2]}
          scale={100}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane009_White_0.geometry}
          material={materials.White}
          position={[-57.492, 15.271, 51.767]}
          rotation={[-0.208, -0.031, -1.596]}
          scale={100}
        />
      </group>
    </group>
  )
}

useGLTF.preload('models/pad.glb')
